import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';

// Scenes
import {
    SPRAY_EVENT_TYPE_CROP,
    SPRAY_EVENT_TYPE_WEED
} from 'services/sprayEventType/constants';
import Diary from './scenes/Diary';
import EquipmentSets from './scenes/EquipmentSets';
import Equipment from './scenes/Equipment';
import Products from './scenes/Products';
import ActiveIngredients from './scenes/ActiveIngredients';
import Submissions from './scenes/Submissions';
import Submission from './scenes/Submission';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Spray = (): React.ReactElement => (
    <ErrorBoundary namespace="Spray" FallbackComponent={<ErrorBoundaryAlert />}>
        <Helmet>
            <title>
                {'Spray - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <Switch>
            <Redirect exact from="/organization/spray" to="/organization" />
            <Route
                key="crop-diary"
                exact
                path="/organization/spray/crop-diary"
                render={(props) => (
                    <Diary {...props} sprayEventType={SPRAY_EVENT_TYPE_CROP} />
                )}
            />
            <Route
                key="weed-diary"
                exact
                path="/organization/spray/weed-diary"
                render={(props) => (
                    <Diary {...props} sprayEventType={SPRAY_EVENT_TYPE_WEED} />
                )}
            />
            <Route
                exact
                path="/organization/spray/equipment-sets"
                component={EquipmentSets}
            />
            <Route
                exact
                path="/organization/spray/equipment"
                component={Equipment}
            />
            <Route
                exact
                path="/organization/spray/products"
                component={Products}
            />
            <Route
                exact
                path="/organization/spray/active-ingredients"
                component={ActiveIngredients}
            />
            <Route
                exact
                path="/organization/spray/submissions"
                component={Submissions}
            />
            <Route
                exact
                path="/organization/spray/submissions/:spraySubmissionId"
                component={Submission}
            />
            <Redirect from="/organization/spray/*" to="/organization" />
        </Switch>
    </ErrorBoundary>
);

export default Spray;
